/** Returns true when the current browser is Firefox. */
export function isFirefox(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  const { userAgent } = window.navigator
  return /firefox/i.test(userAgent) && !/seamonkey/i.test(userAgent)
}
